import React from "react";
import Navbar from "./navbar";
import "./homestyles.css";


const Home = () => {
    return (
    
        <div 
            style={{
                // backgroundImage: 'url("https://img.freepik.com/free-vector/abstract-background-design-with-stars-blue_53876-43533.jpg?t=st=1741695767~exp=1741699367~hmac=e6122b3ef7c2d284f657574692048c1b12dd32cc47069414ac175eec5907c164&w=740")', // Replace with your image path
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                background: "linear-gradient(135deg, #00a7ac, #0073aa)"  }}
        >
            <Navbar />
         
            
        </div>
    );
}

export default Home;
